import { render } from "./BroadcastNotificationAddPage.vue?vue&type=template&id=71790fcc&scoped=true"
import script from "./BroadcastNotificationAddPage.vue?vue&type=script&lang=js"
export * from "./BroadcastNotificationAddPage.vue?vue&type=script&lang=js"

import "./BroadcastNotificationAddPage.vue?vue&type=style&index=0&id=71790fcc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71790fcc"]])

export default __exports__